export default "__VITE_ASSET__fe12a8e1__"